<cheelee-squircle class="squircle" radius="40" >
<!--  <video #targetEl-->
<!--         class="video"-->
<!--         [controls]="false"-->
<!--         src="{{$any(media()).video?.bitrates?.[0]?.url}}" alt=""-->
<!--         poster="{{$any(media()).video?.frame1?.img?.[0]?.url}}"-->
<!--  ></video>-->

  @if (isDesktop()) {
    <cheelee-top-button
        class="mute"
        [icon]="!isMuted() ? 'sprite.svg#icon-not-muted' : 'sprite.svg#icon-muted'"
        (clicked)="toggleMute()"
        [eventName]="analyticsEvents.VolumeTap"
    />
  }

  @if (isMediaType(feedItem())) {
    @let media = $any(feedItem().object);
    <ng-container *ngTemplateOutlet="videoTpl; context: {
                url: media.media_url,
                preview: media.preview_url,
                index: index,
              }"></ng-container>
  }

  @if (isAdsType(feedItem())) {
    @let ad = getAdObject(feedItem());
    @if (ad) {
      <ng-container *ngTemplateOutlet="videoTpl; context: {
                url: ad.video?.bitrates?.[0]?.url,
                preview: ad.video?.frame1?.img?.[0]?.url,
                index: index,
              }"></ng-container>
    }
  }

  @if (isUserVideoType(feedItem())) {
    @let userVideo = $any(feedItem().object);
    <ng-container *ngTemplateOutlet="videoTpl; context: {
                url: userVideo.video?.bitrates?.[0]?.url,
                preview: userVideo.video?.frame1?.img?.[0]?.url,
                index: index,
              }"></ng-container>
  }
  <div class="info">
    <cheelee-about-media
        class="about"
        [item]="feedItem()"
        [isActive]="isVisible()"
    />
    @if (isMediaType(feedItem()) || isUserVideoType(feedItem())) {
      <cheelee-donation />
    }
  </div>

  <div class="effects">
    @if (canShowPauseEffect()) {
      <div
          class="effects__pause-circle fade-in-out"
          (animationend)="canShowPauseEffect.set(false)"
      >
        @if (player.nativeElement.paused) {
          <cheelee-icon
              iconId="pause-video-icon"
              size="12"
          />
        } @else {
          <cheelee-icon
              iconId="play-video-icon"
              size="12"
          />
        }
      </div>
    }

    @if (canShowLikeEffect()) {
      <div
          class="effects__like-effect"
          (animationend)="canShowLikeEffect.set(false)"
      ></div>
    }
  </div>
</cheelee-squircle>

<cheelee-media-actions
    class="actions"
    [item]="feedItem()"
    [mode]="mode"
    (closeComments)="openGetAppDialog(analyticsEvents.MediaCommentTap,'share')"
    (openComments)="openGetAppDialog(analyticsEvents.MediaCommentTap,'share')"
/>

<ng-template #videoTpl let-url="url" let-preview="preview" let-index="index">
  <video
    #htmlVideoElement
    class="video"
    [muted]="isMuted()"
    [poster]="preview"
    [src]="url"
    cheeleeSingleDoubleClick
    loop
    playsinline
    preload="auto"
    [autoplay]="false"
    (canplay)="canShowVideoSpinner.set(false)"
    (loadeddata)="canShowVideoSpinner.set(false)"
    (singleClick)="onVideoClick()"
    (waiting)="canShowVideoSpinner.set(true)"
    [analytics]="htmlVideoElement.paused ? analyticsEvents.MediaPlayTap : analyticsEvents.MediaPauseTap"
  ></video>
</ng-template>